import CmsAPI from '../../common/apis/CmsAPI';

export async function isLoggedIn() {
  const isUserLoggedIn = await CmsAPI.isLoggedIn();
  return isUserLoggedIn;
}

export function isExpired() {
  let sessionExpires = localStorage.getItem('sessionExpires');

  return sessionExpires !== null && Date.now() > sessionExpires;
}

export function getQueryString() {
  const result = {};
  const queryString = window.location.search.slice(1);
  const re = /([^&=]+)=([^&]*)/g;
  let m;

  // eslint-disable-next-line no-cond-assign
  while ((m = re.exec(queryString))) {
    result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
  }
  return result;
}
